import { onMounted, onUnmounted } from "vue";
/**
 * Event name for locale change notifications
 */
const LOCALE_CHANGE_EVENT = "opay:locale-changed";
/**
 * Emit a locale change event
 */
export function emitLocaleChange(newLocale, localeSource = "default") {
    window.dispatchEvent(new CustomEvent(LOCALE_CHANGE_EVENT, {
        detail: { locale: newLocale, source: localeSource },
    }));
}
/**
 * Listen to locale change events
 * Automatically cleans up the listener when the component is unmounted
 */
export function useLocaleChange(callback) {
    const handleLocaleChange = (event) => {
        const customEvent = event;
        if (customEvent.detail?.locale && customEvent.detail?.source) {
            callback(customEvent.detail.locale, customEvent.detail.source);
        }
    };
    onMounted(() => {
        window.addEventListener(LOCALE_CHANGE_EVENT, handleLocaleChange);
    });
    onUnmounted(() => {
        window.removeEventListener(LOCALE_CHANGE_EVENT, handleLocaleChange);
    });
}
/**
 * Add a locale change listener directly (for services, not components)
 * Returns a cleanup function to remove the listener
 */
export function addLocaleChangeListener(callback) {
    const handleLocaleChange = (event) => {
        const customEvent = event;
        if (customEvent.detail?.locale && customEvent.detail?.source) {
            callback(customEvent.detail.locale, customEvent.detail.source);
        }
    };
    window.addEventListener(LOCALE_CHANGE_EVENT, handleLocaleChange);
    // Return cleanup function
    return () => {
        window.removeEventListener(LOCALE_CHANGE_EVENT, handleLocaleChange);
    };
}
